import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import inView from 'in-view';

$(document).ready(function () {
    /* *
   *  Slider fo testomonials
   * */
    $('.testomonials').bxSlider({
        mode: 'fade',
        nextSelector: '#slider-next',
        prevSelector: '#slider-prev',
        pagerCustom: '#owl-carousel',
        touchEnabled: false,
        oneToOneTouch: false
    });
    $('#slider-next a').html('<i class="fa fa-angle-right" aria-hidden="true" ></i>');
    $('#slider-prev a').html('<i class="fa fa-angle-left" aria-hidden="true" ></i>');
    /* *
    *  Slider of testomonials logos
    * */
    let $owl = $("#owl-carousel");
    $owl.children().each( function( index ) {
        $(this).attr( 'data-position', index ); // NB: .attr() instead of .data()
    });
    $owl.owlCarousel({
        center: true,
        items:10,
        loop:true,
        margin:50,
        autoWidth:true,
        mouseDrag: false,
        touchDrag: false,
        responsive:{
            600:{
                items:4
            }
        }
    });
    $('.owl-item>a').click(function() {
        $owl.trigger('to.owl.carousel', $(this).data( 'position' ) );
    });
    $('#slider-next').click(function () {
        $('.owl-nav .owl-next').click();
    });
    $('#slider-prev').click(function () {
        $('.owl-nav .owl-prev').click();
    });
    var myVar;
    inView('.clients_tell_about_us')
        .on('enter', function () {
            myVar = setInterval(function () {
                $('.owl-item.center a').click();
            }, 1000);
        })
        .on('exit', function () {
            clearInterval(myVar);
        });
    if ($(window).width() > 2500) {
        $('.row_of_tiles .space_of_individual_tile').each(function () {
            $(this).find('.tile img').height($(this).width()/2);
        });
    }
});



// WEBPACK FOOTER //
// ./assets/js/home-page.js